export const HIDE_SIGNAL = 'hide';
